// The swatch every home-page style example is painted into.
//
// A checkerboard rather than a flat fill so the frame reads as a preview surface instead of a form
// field, and so a pod with a transparent or semi-transparent background is visibly transparent. The
// dark variant matches the storefront's own dark background, because light-on-dark pod styling has
// to be judged against the backdrop it will ship on.
//
// Shared by the nav pod, category pod and affiliations examples (and by the per-pod preview inside
// the Nav Pods management list) so those four read as one family and the checkerboard is authored
// exactly once.

import React from 'react';

const StyleExampleFrame: React.FC<{
    isDark?: boolean;
    /** Line under the frame. Omitted where the example already sits under a heading of its own. */
    caption?: string;
    /** Pointer enter/leave over the frame, for examples that simulate a `:hover` part. */
    onHoverChange?: (hovered: boolean) => void;
}> = ({ isDark, caption, onHoverChange, children }) => {
    const tint = isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)';
    return (
        <div>
            <div
                onMouseEnter={() => onHoverChange?.(true)}
                onMouseLeave={() => onHoverChange?.(false)}
                style={{
                    display: 'flex', justifyContent: 'center', padding: '0.75em', borderRadius: 4,
                    // The frame supplies the text color the pod inherits (pod styles override it),
                    // so an unstyled pod is legible on either backdrop.
                    color: isDark ? '#f3f2f1' : undefined,
                    backgroundColor: isDark ? '#2b2b2b' : '#faf9f8',
                    backgroundImage: `linear-gradient(45deg, ${tint} 25%, transparent 25%, transparent 75%, ${tint} 75%), linear-gradient(45deg, ${tint} 25%, transparent 25%, transparent 75%, ${tint} 75%)`,
                    backgroundSize: '16px 16px',
                    backgroundPosition: '0 0, 8px 8px',
                }}
            >
                {children}
            </div>
            {caption && <div style={{ fontSize: 11, color: '#605e5c', marginTop: 4 }}>{caption}</div>}
        </div>
    );
};

export default StyleExampleFrame;
